import { marked } from 'marked';
import { gfmHeadingId } from 'marked-gfm-heading-id';

marked.use(gfmHeadingId());

const sidebarLinksNL = [
  {
    text: 'Privacybeleid',
    href: '/privacy/',
  },
  {
    text: 'Cookies',
    href: '/cookies/',
  },
  {
    text: 'Algemene voorwaarden',
    href: '/algemene-voorwaarden/',
  },
];

const sidebarLinksEN = [
  {
    text: 'Privacy policy',
    href: '/privacy/',
  },
  {
    text: 'Cookies',
    href: '/cookies/',
  },
  {
    text: 'Terms and conditions',
    href: '/terms-and-conditions/',
  },
];

const contentMDWebshopNl = '# Algemene voorwaarden';
const contentMDShopblogNl = `# Algemene voorwaarden`;

const contentMDShopsAE = `
# Terms and Conditions
## Who is Shops.ae?
Shops.ae is a brand of Webshop B.V.. Webshop B.V. (or to be named Webshop.nl), by using the services of Shops.ae you agree upon the terms and conditions applied by Webshop B.V.

Webshop B.V. is an Internet company that presents the Dutch product supply of web shops by means of a product search engine. Webshop B.V. does not sell products itself but unlocks the products that are offered for sale by third parties. When a consumer has decided to make an online purchase, the consumer will order it direct from the participating web shop. Webshop B.V. is established in Almere at De Strubbenweg 27, and is registered with the Chamber of Commerce under number 66829704.

## General
The use of Webshop.nl is subject to these Conditions of Use, the Privacy Policy and the Cookie Policy. If you do not agree to the contents of these documents, you should not make use of Webshop.nl. Webshop B.V. reserves the right to modify these Conditions of Use at any time and without prior notice. The modifications will take effect immediately unless something else is stated. This will be announced by publication on the website and/or by dispatch of a communication by email to all account holders of Webshop.nl. If you continue to use Webshop.nl after the modifications, this implies that you accept these alterations irrevocably. It is therefore sensible and the consumer's responsibility to consult the Conditions of Use regularly.

## To what do the Conditions of Use apply?
These Conditions of Use apply to all agreements, all services and all offers of Webshop.nl, unless something else has been indicated. Deviations from these Conditions of Use only apply if they have been agreed beforehand and explicitly in writing.

## Your rights and duties
As a user of Webshop.nl you are to adopt an attitude and you are to behave yourself in all respects as may be expected of a responsible and careful Internet user. Among other things it will not be permitted to use the (content of) Webshop.nl for acts and/or behaviour contrary to the law, public order or good morals. More in particular the following acts and/or conduct will not be permitted:

1. infringing or otherwise acting contrary to the intellectual property rights of Webshop B.V. and/or third parties;
2. evading and or removing the security of (parts of) Webshop.nl.
3. making infringing, wrongful or misleading statements;
4. distributing legally forbidden material;

all textual and visual information on the Webshop.nl site is protected by copyright. The copyright of this site lies with Webshop BV. It is not permitted, without prior written permission of Webshop BV, to otherwise copy, alter, distribute, decompile, reverse engineer, or otherwise use and/or commercially exploit the material made available. If the above-mentioned permitted use is not observed, Webshop B.V. reserves the right to recover from you any damage that follows from this unpermitted use.

## How does Webshop treat your personal data?
In the Privacy Policy you can read what use Webshop B.V. makes of the data that are collected about you on Webshop.nl and how you can change these data or have them removed. In the Cookie Policy you will find more information about the cookies that Webshop.nl uses. The Privacy Policy and the Cookie Policy only relate to Webshop.nl and not to other websites for which links are offered on Webshop.nl. Webshop.nl displays information and products of and about different web shops. Webshop B.V. does not guarantee that the information and material presented on Webshop.nl is up-to-date, complete and/or accurate. Webshop.nl keeps track of the changes of the web shops in the best possible manner, but when changes are made at the web shops, such as product or price changes, it may happen that these web shops do not pass them on in time. Webshop B.V. therefore does not guarantee that the information supplied on Webshop.nl is free of errors, defects and/or viruses. Webshop B.V. furthermore does not guarantee that such errors and/or defects in the website will be repaired or viruses will be removed. In the event of doubt about the correctness of the data or in the event of discovery of inaccuracies we advise you to contact the person who offers the relevant information (often the selling web shop).

## What law applies to these Conditions of Use?
Dutch law applies to these Conditions of Use. Any dispute about these Conditions of Used will be submitted to the competent court of Amsterdam.

## Questions?
If you have any questions in connection with these Conditions of Use please do not hesitate to contact us. Webshop B.V. Chamber of Commerce: 66829704 P.O. Box 22123 1302CC Almere info@shops.ae 088 85 85 580 These Conditions of Use were modified on 18 December 2017.
`;

const contentVersions = {
  'webshop-nl': () => contentMDWebshopNl,
  'shopblog-nl': () => contentMDShopblogNl,
  'shops-ae': () => contentMDShopsAE,
};

const sidebarLinksVersions = {
  'webshop-nl': () => sidebarLinksNL,
  'shopblog-nl': () => sidebarLinksNL,
  'shops-ae': () => sidebarLinksEN,
};

export const TermsAndConditionsPageDataLoader = async () => {
  try {
    const contentMD = contentVersions[process.env.REACT_APP_NAME]();
    const sidebarLinks = sidebarLinksVersions[process.env.REACT_APP_NAME]();

    if (!contentMD) throw new Response('Not Found', { status: 404 });
    const content = marked.parse(contentMD);
    return { content, sidebarLinks };
  } catch (error) {
    throw new Response(error.message, { status: 404 });
  }
};
